export const namespaced = true;

export const mutations = {};

export const actions = {};

export const state = {
  reports: [
    {
      id: 1,
      name: 'Basic - By Date',
      properties: {
        reportFilenamePrefix: 'Basic-by-date',
        reportName: 'basic-by-date',
        reportClient: true
      },
      component: () =>
        import(/* webpackChunkName: "by-date-export-dialog" */ '../../views/dialogs/reports/ByDateExportDialog')
    },
    {
      id: 2,
      name: 'Basic - Cancellation',
      properties: {
        reportFilenamePrefix: 'Basic-Cancellation',
        reportName: 'basic-cancellation',
        reportClient: true
      },
      component: () =>
        import(/* webpackChunkName: "by-date-export-dialog" */ '../../views/dialogs/reports/ByDateExportDialog')
    },
    {
      id: 4,
      name: 'Certificate of Attendance',
      properties: {
        reportFilenamePrefix: 'Certificate of Attendance',
        reportName: 'certificate-of-attendence'
      },
      component: () =>
        import(/* webpackChunkName: "attendance-export-dialog" */ '../../views/dialogs/reports/AttendanceExportDialog')
    },
    {
      id: 5,
      name: 'Deadlines',
      properties: {
        reportFilenamePrefix: 'Deadlines',
        reportName: 'deadlines',
        reportClient: true
      },
      component: () =>
        import(/* webpackChunkName: "group-export-dialog" */ '../../views/dialogs/reports/ByDateExportDialog')
    },
    {
      id: 6,
      name: 'Host Families - By Postcode',
      properties: {
        reportFilenamePrefix: 'Host-Family-By-Postcode',
        reportName: 'host-family-by-post-code'
      },
      component: () =>
        import(/* webpackChunkName: "postcode-export-dialog" */ '../../views/dialogs/reports/PostCodeExportDialog')
    },
    {
      id: 21,
      name: 'Active Host Families (state)',
      properties: {
        reportFilenamePrefix: 'Active Host Families (state)',
        reportName: 'host-families-by-state',
        reportClient: false,
        defaultFileType: 'html',
        allowedFileTypes: ['html']
      },
      component: () =>
        import(/* webpackChunkName: "by-date-export-dialog" */ '../../views/dialogs/reports/ByStateDialog')
    },
    {
      id: 19,
      name: 'Host Family working with children report (year, state)',
      properties: {
        reportFilenamePrefix: 'Host Family working with children report',
        reportName: 'host-families-wwc',
        reportClient: false,
        defaultFileType: 'html',
        allowedFileTypes: ['html']
      },
      component: () =>
        import(/* webpackChunkName: "by-date-export-dialog" */ '../../views/dialogs/reports/ByYearExportDialog')
    },
    {
      id: 7,
      name: 'Host Family without working with children card details (dates)',
      properties: {
        reportFilenamePrefix: 'Host Family without working with children card details',
        reportName: 'host-family-incomplete-blue-card',
        reportClient: false
      },
      component: () =>
        import(/* webpackChunkName: "by-date-export-dialog" */ '../../views/dialogs/reports/ByDateExportDialog')
    },
    {
      id: 15,
      name: 'Host Family without working with children card details (group)',
      properties: {
        reportFilenamePrefix: 'Host Family without working with children card details',
        reportName: 'host-family-incomplete-blue-card-group',
        reportClient: false
      },
      component: () =>
        import(/* webpackChunkName: "by-date-export-dialog" */ '../../views/dialogs/reports/GroupExportDialog')
    },
    {
      id: 8,
      name: 'Itinerary',
      properties: {
        reportFilenamePrefix: 'Itinerary',
        reportName: 'itinerary'
      },
      component: () =>
        import(/* webpackChunkName: "group-export-dialog" */ '../../views/dialogs/reports/GroupExportDialog')
    },
    {
      id: 20,
      name: 'Itinerary Codes',
      properties: {
        reportFilenamePrefix: 'Itinerary-Codes',
        reportName: 'itinerary-codes',
        defaultFileType: 'pdf',
        allowedFileTypes: ['pdf', 'csv']
      },
      component: () =>
        import(/* webpackChunkName: "group-export-dialog" */ '../../views/dialogs/reports/BasicExportDialog')
    },
    {
      id: 9,
      name: 'Name List',
      properties: {
        reportFilenamePrefix: 'Name-List',
        reportName: 'namelist'
      },
      component: () =>
        import(/* webpackChunkName: "group-export-dialog" */ '../../views/dialogs/reports/GroupExportDialog')
    },
    {
      id: 10,
      name: 'Name List - Accounts',
      properties: {
        reportFilenamePrefix: 'Name-List-Accounts',
        reportName: 'namelist-accounts'
      },
      component: () =>
        import(/* webpackChunkName: "group-export-dialog" */ '../../views/dialogs/reports/GroupExportDialog')
    },
    {
      id: 11,
      name: 'Name List - Japan',
      properties: {
        reportFilenamePrefix: 'Name-List-Japan',
        reportName: 'namelist-japan'
      },
      component: () =>
        import(/* webpackChunkName: "group-export-dialog" */ '../../views/dialogs/reports/GroupExportDialog')
    },
    {
      id: 12,
      name: 'Name List - Summary',
      properties: {
        reportFilenamePrefix: 'Name-List-Summary',
        reportName: 'namelist-summary'
      },
      component: () =>
        import(/* webpackChunkName: "group-export-dialog" */ '../../views/dialogs/reports/GroupExportDialog')
    },
    {
      id: 13,
      name: 'Standard 1 - By Date',
      properties: {
        reportFilenamePrefix: 'Standard-1',
        reportName: 'standard',
        reportClient: false
      },
      component: () =>
        import(/* webpackChunkName: "by-date-export-dialog" */ '../../views/dialogs/reports/ByDateExportDialog')
    },
    {
      id: 14,
      name: 'Standard 2 - By Date',
      properties: {
        reportFilenamePrefix: 'Standard-2',
        reportName: 'standard-alternative',
        reportClient: false
      },
      component: () =>
        import(/* webpackChunkName: "by-date-export-dialog" */ '../../views/dialogs/reports/ByDateExportDialog')
    },
    {
      id: 3,
      name: 'Working with children report',
      properties: {
        reportFilenamePrefix: 'Working-With-Children-Detail-Report',
        reportName: 'bluecard',
        defaultFileType: 'xlsx',
        allowedFileTypes: ['xlsx']
      },
      component: () =>
        import(/* webpackChunkName: "group-export-dialog" */ '../../views/dialogs/reports/GroupExportDialog')
    },
    {
      id: 30,
      name: 'Staff Postal Address by State',
      properties: {
        reportFilenamePrefix: 'Staff Postal Address by State',
        reportName: 'staff-postal-report',
        defaultFileType: 'html',
        allowedFileTypes: ['html']
      },
      component: () =>
        import(
          /* webpackChunkName: "staff-postal-by-state-dialog" */ '../../views/dialogs/reports/StaffPostalByStateDialog'
        )
    }
  ]
};

export const getters = {
  availableReports: state => {
    return state.reports;
  }
};
